import { lazySetRightPaneDisplayAndUpdateSize, RightPaneDisplay } from 'owa-sxsdata';
import { orchestrator } from 'satcheljs';
import { onComposeStateChange } from '../actions/internalActions';
import { openComposeInSxS } from '../actions/publicLazyActions';
import sxsStore from '../store/Store';

async function openComposeInSxSOrchestrator(actionMessage: { composeViewState: any }) {
    const { composeViewState } = actionMessage;

    if (
        composeViewState?.composeId &&
        (sxsStore.viewState.rightPaneDisplay === RightPaneDisplay.Hide ||
            sxsStore.viewState.hideRightPane)
    ) {
        const setRightPaneDisplayAndUpdateSize = await lazySetRightPaneDisplayAndUpdateSize.import();
        setRightPaneDisplayAndUpdateSize(sxsStore.viewState, RightPaneDisplay.Show);
    }
}

orchestrator(openComposeInSxS, openComposeInSxSOrchestrator);
orchestrator(onComposeStateChange, openComposeInSxSOrchestrator);
